(() => {
  const allowed=new Set(['new','all','brand']);
  const contextFromUrl=()=>{const c=new URL(location.href).searchParams.get('fl4_context');return allowed.has(c)?c:'brand';};
  const shuffle=list=>{const a=list.slice();for(let i=a.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[a[i],a[j]]=[a[j],a[i]];}return a;};
  function tag(link,context){const u=new URL(link.href,location.href);if(u.origin!==location.origin||!u.pathname.includes('/products/'))return;u.searchParams.set('fl4_context',context);link.href=u.href;}
  function diversify(pool){
    const groups=new Map();shuffle(pool).forEach(item=>{const v=item.dataset.vendor||'';if(!groups.has(v))groups.set(v,[]);groups.get(v).push(item);});
    const result=[];while(groups.size){for(const vendor of shuffle(Array.from(groups.keys()))){const group=groups.get(vendor);result.push(group.shift());if(!group.length)groups.delete(vendor);}}return result;
  }
  function recommend(section){
    const context=contextFromUrl(),vendor=section.dataset.fl4Vendor;
    const candidates=Array.from(section.querySelectorAll('template[data-fl4-candidate]'));
    let pool=candidates.filter(t=>context==='new'?t.dataset.new==='true':context==='brand'?t.dataset.vendor===vendor:true);
    const track=section.querySelector('[data-fl4-related-track]');
    if(!pool.length){section.hidden=true;return;}
    const key='fl4-recommendations-v2:'+context+(context==='brand'?':'+vendor:'');
    let last=[];try{last=JSON.parse(sessionStorage.getItem(key)||'[]');}catch(e){}
    const previous=new Set(last);
    const fresh=pool.filter(t=>!previous.has(t.dataset.fl4Candidate));
    const repeat=pool.filter(t=>previous.has(t.dataset.fl4Candidate));
    const count=Math.min(Number(section.dataset.fl4Limit)||8,pool.length);
    let chosen=diversify(fresh).concat(diversify(repeat)).slice(0,count);
    if(chosen.length>1&&chosen.map(t=>t.dataset.fl4Candidate).join('|')===last.join('|'))chosen.push(chosen.shift());
    const fragment=document.createDocumentFragment();
    chosen.forEach(t=>{const node=t.content.cloneNode(true);node.querySelectorAll('a[href*="/products/"]').forEach(a=>tag(a,context));fragment.appendChild(node);});
    track.replaceChildren(fragment);
    section.dataset.fl4Context=context;
    const viewAll=section.querySelector('[data-fl4-related-view-all]');
    if(viewAll)viewAll.href=section.dataset[context==='brand'?'fl4UrlBrand':context==='new'?'fl4UrlNew':'fl4UrlAll'];
    section.dataset.fl4Selection=chosen.map(t=>t.dataset.fl4Candidate).join(',');
    section.querySelector('[data-fl4-related-heading]').textContent=section.dataset[context==='brand'?'fl4HeadingBrand':context==='new'?'fl4HeadingNew':'fl4HeadingAll'];
    try{sessionStorage.setItem(key,JSON.stringify(chosen.map(t=>t.dataset.fl4Candidate)));}catch(e){}
  }
  function navigation(root=document){
    root.querySelectorAll('[data-fl4-collection-handle]').forEach(section=>{
      const handle=section.dataset.fl4CollectionHandle;
      const context=handle==='new-positions'?'new':['all','catalog','all-sneakers'].includes(handle)?'all':'brand';
      section.querySelectorAll('a[href*="/products/"]').forEach(a=>tag(a,context));
    });
    root.querySelectorAll('[id="new-positions"] a[href*="/products/"], [id="new-arrivals"] a[href*="/products/"]').forEach(a=>tag(a,'new'));
  }
  function boot(root=document){navigation(root);root.querySelectorAll('[data-fl4-related]').forEach(recommend);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
  window.addEventListener('pageshow',e=>{if(e.persisted)boot();});
})();
